import  * as yup from "yup";
export const OrderTreatmentSchema = yup.object({
    order_type: yup
    .string()
    .required(`Order type is required`),
    po_number: yup
    .string(),
});
